import { FormEvent, JSX } from "react";
import { useTranslation } from "react-i18next";
import { FramerButton } from "@/components/shared";

type Props = {
  id: string;
  handleSubmit: (_event: FormEvent<Element>) => void;
  children: JSX.Element;
  onClickReset: () => void;
  className?: string;
};

function FormWrapper(props: Props) {

  // Props
  const { handleSubmit, children, onClickReset, className, id } = props;

  // Hooks
  const { t } = useTranslation(["common"]);

  return (
    <form id={id} onSubmit={handleSubmit} className={className}>
      {children}
      <div className="space-x-2 mt-4">
        <FramerButton
          type="button"
          onClick={onClickReset}
          variant="outline-primary"
        >
          {t("buttons.reset")}
        </FramerButton>
        <FramerButton
          type="submit"
          className="bg-mforange text-white hover:bg-mforange/80"
        >
          {t("buttons.submit")}
        </FramerButton>
      </div>
    </form>
  );
}

export default FormWrapper;
